import { Switch } from 'antd'
import BadgeStatus from './BadgeStatus'

export default function SwitchStatus({
  value,
  onChange,
  isViewMode = false,
  activeText = 'Active',
  inactiveText = 'Inactive',
}) {
  const isActive = !!value

  if (isViewMode) {
    return (
      <>
        <span>: </span>
        <BadgeStatus
          isActive={isActive}
          activeText={activeText}
          inactiveText={inactiveText}
        />
      </>
    )
  }

  return (
    <div className="d-flex align-items-center gap-2">
      <Switch
        checked={isActive}
        onChange={onChange}
        className="switch-active-green"
      />
      <span
        style={{
          fontSize: 14,
          fontWeight: 400,
          color: 'var(--color-on-base-content-subtle)',
        }}
      >
        {isActive ? activeText : inactiveText}
      </span>
    </div>
  )
}
